/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
// import {defaultCreateAppData, ICreateAppData} from './IAppModels' // omitting due to eslint warning
import {StepperComponent} from '../../../assets/ts/components'
import {KTIcon} from '../../../helpers'
// import {Step1} from './steps/Step1'
// import {Step2} from './steps/Step2'
// import {Step3} from './steps/Step3'
// import {Step4} from './steps/Step4'
// import {Step5} from './steps/Step5'

type Props = {
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({show, handleClose}: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  // const [data, setData] = useState<ICreateAppData>(defaultCreateAppData) // omitting due to eslint warning
  // const [hasError, setHasError] = useState(false) // omitting due to eslint warning

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  // omitting due to eslint warning
  // const updateData = (fieldsToUpdate: Partial<ICreateAppData>) => {
  //   const updatedData = {...data, ...fieldsToUpdate}
  //   setData(updatedData)
  // }

  // omitting due to eslint warning
  // const checkAppBasic = (): boolean => {
  //   if (!data.appBasic.appName || !data.appBasic.appType) {
  //     return false
  //   }
  //   return true
  // }

  // omitting due to eslint warning
  // const checkAppDataBase = (): boolean => {
  //   if (!data.appDatabase.databaseName || !data.appDatabase.databaseSolution) {
  //     return false
  //   }

  //   return true
  // }

  // omitting due to eslint warning
  // const prevStep = () => {
  //   if (!stepper.current) {
  //     return
  //   }

  //   stepper.current.goPrev()
  // }

  // omitting due to eslint warning
  // const nextStep = () => {
  //   setHasError(false)
  //   if (!stepper.current) {
  //     return
  //   }

  //   if (stepper.current.getCurrentStepIndex() === 1) {
  //     if (!checkAppBasic()) {
  //       setHasError(true)
  //       return
  //     }
  //   }

  //   if (stepper.current.getCurrentStepIndex() === 3) {
  //     if (!checkAppDataBase()) {
  //       setHasError(true)
  //       return
  //     }
  //   }

  //   stepper.current.goNext()
  // }

  // const submit = () => { window.location.reload() }  // omitting due to eslint warning

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2 className=''>Header</h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTIcon className='fs-1' iconName='cross' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
              <h1 className='text-center'>Select the Type of Your Experience</h1>
              <div className='py-4'>
                <h2 className='text-dark py-2'>Most Popular Types</h2>
                <div className='d-flex flex-wrap align-items-center gap-2'>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/1544c93.png" alt=""/>
                  </div>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/89b03e3.png" alt=""/>
                  </div>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/aeacf6e.png" alt=""/>
                  </div>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/b9a70fe.png" alt=""/>
                  </div>
                </div>
              </div>

              <div className='mt-10'>
                <h2 className='text-dark py-2'>All Experience</h2>
                <div className='d-flex align-items-center gap-2'>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/fdbb47f.png" alt=""/>
                  </div>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/ca0d3b7.png" alt=""/>
                  </div>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/be2293e.png" alt=""/>
                  </div>
                  <div className=''>
                        <img className='w-200px h-150px rounded object-fit-cover' src="https://dashboard.mywebar.com/_nuxt/img/474fd0d.png" alt=""/>
                  </div>
                </div>
              </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {CreateAppModal}
